/** First message in a react-hook-form error object for one array item, e.g. `errors.partialCompany.address[0]`. */
export const firstErrorMessage = (fieldErrors: unknown): string | undefined => {
  if (!fieldErrors || typeof fieldErrors !== "object") return undefined;
  for (const value of Object.values(fieldErrors as Record<string, { message?: unknown } | undefined>)) {
    if (value && typeof value.message === "string") return value.message;
  }
  return undefined;
};
